<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('configuracionAlmacen')}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           @change="cambioNegocio()"
                                           :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">

                    <div class="row">
                        <div class="col-md-4"></div>

                        <div class="col-md-4 text-right">
                            <el-select class="select-default filterTag"
                                       size="large"
                                       v-model="filter"
                                       filterable
                                       @change="cambioFiltro()"
                                       :placeholder="$t('seleccionaNegocio')">
                                <el-option v-for="filter in filterTag"
                                           class="select-primary"
                                           :value="filter.id"
                                           :label="filter.name"
                                           :key="filter.id">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="col-md-4 text-right">
                            <div class="input-group">
                                <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                       v-model="searchQuery"
                                       @keyup.enter.prevent="searchSubproductos">
                                <div class="input-group-append">
                                    <button class="btn btn-secondary" type="button" @click="searchSubproductos"><i
                                            class="fa fa-search"></i>
                                    </button>
                                    <button class="btn btn-secondary" type="button" @click="removeSearch"><i
                                            class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="isSearch">
                        <div class="col-md-12">
                            <p>
                                <small>{{showResult}}</small>
                            </p>
                        </div>
                    </div>

                    <div v-if="listSubproducts.length>0">
                        <div class="table-responsive">

                            <table class="table table-bordered table-striped">

                                <thead class="thead-dark">
                                <tr>
                                    <th>{{$t("materiaPrima")}}</th>
                                    <th>Escandallo</th>
                                    <th>Stock minimo</th>
                                    <th>Stock mínimo partes</th>
                                    <th>Stock optimo</th>
                                    <th>Precio compra</th>
                                    <th>Proveedor</th>
                                    <th>Etiqueta</th>
                                    <th>Casa</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="sub in listSubproducts">
                                    <td width="20%">
                                        <div>{{sub.name}}
                                            <span style="color: red" v-if="sub.baja=='1'">
                                            [{{$t("BAJA")}}]
                                        </span>
                                        </div>
                                    </td>
                                    <td width="10%">
                                        <div>

                                            <input @blur="editSubproduct(sub)"
                                                   class="form-control" type="number"
                                                   v-model="sub.escandallo"/>

                                        </div>
                                    </td>
                                    <td width="10%">
                                        <div><input @blur="editSubproduct(sub)"
                                                    class="form-control" type="number"
                                                    v-model="sub.stockminimo"/></div>
                                    </td>
                                    <td>
                                        <div><input @blur="editSubproduct(sub)"
                                                    class="form-control" type="number"
                                                    v-model="sub.stockminimopartes"/></div>
                                    </td>
                                    <td>
                                        <div><input @blur="editSubproduct(sub)"
                                                    class="form-control" type="number"
                                                    v-model="sub.stockoptimo"/></div>
                                    </td>
                                    <td>
                                        <div><input @blur="editSubproduct(sub)"
                                                    class="form-control" type="number"
                                                    v-model="sub.precio_compra"/></div>
                                    </td>
                                    <td>
                                        <div>
                                            <el-select class="select-default"
                                                       size="large"
                                                       v-model="sub.idProveedor"
                                                       filterable
                                                       @change="editSubproduct(sub)"
                                                       :placeholder="$t('seleccionaNegocio')"
                                            >
                                                <el-option v-for="suppl in listSuppliers"
                                                           class="select-primary"
                                                           :value="suppl.id"
                                                           :label="suppl.name"
                                                           :key="suppl.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <el-select class="select-default"
                                                       size="large"
                                                       v-model="sub.idTag"
                                                       @change="editSubproduct(sub)"
                                                       filterable
                                                       :placeholder="$t('seleccionaNegocio')">
                                                <el-option v-for="tag in filterTag"
                                                           class="select-primary"
                                                           :value="tag.id"
                                                           :label="tag.name"
                                                           :key="tag.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </td>
                                    <td>
                                        <div>

                                            <el-select class="select-default"
                                                       size="large"
                                                       v-model="sub.idCasa"
                                                       @change="editSubproduct(sub)"
                                                       filterable
                                                       :placeholder="$t('seleccionaNegocio')"
                                            >
                                                <el-option v-for="casa in listCasas"
                                                           class="select-primary"
                                                           :value="casa.id"
                                                           :label="casa.name"
                                                           :key="casa.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t("subproductosCreados")}}</strong> {{$t("enEsteNegocio")}}
                    </div>

                    <div class="row" v-if="!isSearch && totalPags > 1">
                        <div class="col-md-12">
                            <nav>
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" :class="{'disabled':pag == 1}">
                                        <router-link class="page-link"
                                                     :to="{name: 'configuracion-almacen', params: {pag: pag-1}}"
                                                     v-if="pag != 1">&laquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                    </li>
                                    <li class="page-item" v-for="n in totalPags" :class="{active : n == pag}">
                                        <router-link class="page-link"
                                                     :to="{name: 'configuracion-almacen', params: {pag:n}}">
                                            {{n}}
                                        </router-link>
                                    </li>
                                    <li class="page-item" :class="{'disabled':pag == totalPags}">
                                        <router-link class="page-link"
                                                     :to="{name: 'configuracion-almacen', params: {pag: nextPag}}"
                                                     v-if="pag != totalPags">
                                            &raquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import { mapState } from 'vuex';

    export default {

        created() {
           this.loadingGeneral = Loading.service({text: this.$t('cargando')});
            this.$store.dispatch("setNameRoute", this.$i18n.t("subproductos"));
            this.getBusiness();

            var filtro = this.$route.query.filtro;
            if (filtro != undefined) {
                this.filter = parseInt(filtro);
            }


        },
        updated() {

            this.nPeticiones++;

                if (this.nPeticiones === 5) {
                    this.loadingGeneral.close();
                }


        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                nPeticiones: 0,
                loadingGeneral: null,

                loading: false,
                listBusinesses: [],
                listCategory: ["-"],
                idBusiness: this.$route.params.idBusiness,
                searchQuery: this.$route.params.query,
                isSearch: false,
                pag: this.$route.params.pag,
                totalPags: 0,
                listSubproducts: ["-"],
                filterTag: [],
                filter: 0,

                listSuppliers: [],
                idSupplier: 0,

                listTags: [],

                listCasas: [],
                idCasa: 0,

                respuesta: true,
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.params.pag) {
                    this.pag = to.params.pag;
                    this.getSubproducts();
                } else if (to.params.query) {
                    this.query = to.params.query;
                    this.getSubproducts();
                }
            }
        },
        computed: {
            ...mapState(["permiso"]),
            showResult() {
                if (this.listSubproducts.length == 0) {
                    return this.$t('noEncontramosResultadosPara') + this.searchQuery;
                } else {
                    const result = this.listSubproducts.length == 1 ? this.$t('resultado') : this.$t('resultados');
                    return this.$t('mostrando')+" " + this.listSubproducts.length + " " + result;
                }
            },
            nextPag() {
                let nextPag = parseInt(this.pag) + 1;
                return nextPag;
            }
        },
        methods: {

            cambioNegocio() {
                this.pag = 1;
                this.totalPags = 0;
                this.filter = 0;
                this.getCategory();
                this.getProveedores();
                this.getCasas();
                this.getSubproducts();

            },
            cambioFiltro() {


                this.pag = 1;
                this.totalPags = 0;
                this.getSubproducts();

            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        if(response.data.response) {

                            if (vm.$store.getters.idBusiness) {
                                vm.idBusiness = vm.$store.getters.idBusiness;
                            } else {
                                vm.idBusiness = response.data.result[0].id;
                            }

                            vm.listBusinesses = response.data.result;
//                        vm.loading.close();
                            vm.getSubproducts();
                            vm.getCategory();
                            vm.getProveedores();
                            vm.getCasas();
                        }
                        else{
                            vm.loadingGeneral.close();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            editSubproduct(subproduct) {

                if (subproduct.escandallo !=='' && subproduct.stockminimo!=='' && subproduct.stockminimopartes!=='' && subproduct.stockoptimo !=='' && subproduct.precio_compra !=='') {


                    this.inProgress = true;

                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        subproduct: subproduct,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = "editSubproductsAlmacenConfiguracionById";
                    this.axios.post(this.$store.getters.apiUrl + 'subproducts/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.$t('actualizada');
                                vm.$notify({
                                    message: vm.$t('subproducto')+ ' ' + notify + ' ' + vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });


                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
                }
                else {

                    swal({
                        title: vm.$t('atencion'),
                        text: vm.$t('noSeAdmitenCamposEnBlanco'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }

            },

            getCategory() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'subproducts/getCategoryByBusinesses', config)
                    .then(function (response) {
                        if (response.data.response) {


                            vm.filterTag = [];

                            if (response.data.result.length === 0) {

                                let category = {
                                    name: vm.$t('sinEtiqueta'),
                                    id: 0
                                };

                                vm.filterTag.push(category);

                            }

                            for (let i = 0; i < response.data.result.length; i++) {

                                if (i === 0) {

                                    let category = {
                                        name: vm.$t('sinEtiqueta'),
                                        id: 0
                                    };

                                    vm.filterTag.push(category);

                                }


                                let categoryname = {
                                    name: response.data.result[i].name,
                                    id: response.data.result[i].id,
                                };

                                vm.filterTag.push(categoryname)

                            }


                        } else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            getProveedores() {

                const controller = 'getSuppliersByBusiness';
                var config = {
                    params: {
                        pag: 0,
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "suppliers/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.listSuppliers=[];

                            if (response.data.result.suppliers.length === 0) {

                                let proveedor = {
                                    name: vm.$t('sinProveedor'),
                                    id: '0'
                                };

                                vm.listSuppliers.push(proveedor);
                            }

                            for (let i = 0; i < response.data.result.suppliers.length; i++) {

                                if (i === 0) {

                                    let proveedor = {
                                        name: vm.$t('sinProveedor'),
                                        id: '0'
                                    };

                                    vm.listSuppliers.push(proveedor);

                                }

                                let proveedorname = {
                                    name: response.data.result.suppliers[i].name,
                                    id: response.data.result.suppliers[i].id,
                                };

                                vm.listSuppliers.push(proveedorname)

                            }


                        }
                        else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getCasas() {
                this.listCasas = [];

                const controller = 'getCasasByBusiness';
                var config = {
                    params: {
                        pag: 0,
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "casas/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.listCasas=[];

                            if (response.data.result.casas.length > 0) {
                                vm.listCasas = response.data.result.casas;
                            }

                            let xCasa = {
                                name: vm.$t('sinCasa'),
                                id: "0"
                            };

                            vm.listCasas.unshift(xCasa);

                        }
                        else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSubproducts() {

                const controller = this.searchQuery ? 'searchSubproductsAlmacenConfiguracion/' + this.searchQuery : 'getSubproductsAlmacenConfiguracionByBusiness';
                var config = {
                    params: {
                        pag: this.pag,
                        idBusiness: this.idBusiness,
                        filter: this.filter,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listSubproducts = response.data.result.listSubproduct;
                            vm.pag = response.data.result.pag;
                            vm.totalPags = response.data.result.totalPags;

                            vm.respuesta = true;

                        }
                        else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            searchSubproductos() {
                if (this.searchQuery !== undefined && this.searchQuery !== "") {
                    this.$router.push({name: 'search-configuracion-almacen', params: {query: this.searchQuery}});
                    this.isSearch = true;
                }
            },
            removeSearch() {
                if (this.searchQuery && this.searchQuery !== "") {
                    this.searchQuery = "";
                    this.isSearch = false;
                    this.$router.push({name: 'configuracion-almacen'});
                    this.getSubproducts()
                }
            }
        }
    }
</script>

<style scoped>


    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
        cursor: pointer;
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Almacen/ConfiguracionAlmacen.vue